import { z } from 'zod/v4';

/**
 * Body of `POST /api/questionnaires/templates`, ported from the legacy
 * `create.body` JSON Schema in
 * `routes/schemas/v1/request/templates.js`.
 *
 * Deliberately narrower than `CreateQuestionnaireBodySchema`: the legacy
 * template handler forced `status = 'DRAFT'` and `dueDate`/`templateId` to
 * `null` regardless of the payload, so none of the three is accepted here.
 *
 * `status` in particular is *sent* by every real caller — both frontends post
 * `{ name, status: 'DRAFT' }`. The legacy schema declared
 * `additionalProperties: false` but Fastify's AJV config stripped extras
 * silently rather than answering 400, and zod's object default strips them the
 * same way. Keeping it out of this schema is what preserves that: the key is
 * ignored, not rejected.
 */
export const CreateQuestionnaireTemplateBodySchema = z.object({
  name: z.string().min(1).max(255),
  description: z.string().min(1).max(1024).optional(),
});

export type CreateQuestionnaireTemplateBody = z.infer<
  typeof CreateQuestionnaireTemplateBodySchema
>;
